import { ActionType, createAction } from "typesafe-actions";

import type { ExecutiveSummarySchedule } from "@mapmycustomers/shared/types/entity/executiveSummarySchedule";

import type { ScheduleConfig } from "@app/component/executiveSummary/types";
import Scope from "@app/types/dashboard/Scope";

export const fetchExecutiveSummarySchedule = createAction(
  "@dashboard/fetchExecutiveSummarySchedule"
)<{
  callback: (schedule: ExecutiveSummarySchedule | null) => void;
  failureCallback?: () => void;
  scope: Scope;
}>();

export const saveExecutiveSummarySchedule = createAction(
  "@dashboard/saveExecutiveSummarySchedule"
)<{
  callback: (schedule: ExecutiveSummarySchedule) => void;
  config: ScheduleConfig;
  existingId?: ExecutiveSummarySchedule["id"];
  failureCallback?: () => void;
  scope: Scope;
}>();

export const clearExecutiveSummarySchedule = createAction(
  "@dashboard/clearExecutiveSummarySchedule"
)<{
  callback?: () => void;
  failureCallback?: () => void;
  scheduleId: ExecutiveSummarySchedule["id"];
}>();

export type ExecutiveSummaryScheduleActions = ActionType<
  | typeof clearExecutiveSummarySchedule
  | typeof fetchExecutiveSummarySchedule
  | typeof saveExecutiveSummarySchedule
>;
